import { Skeleton } from 'antd';
import React, { FunctionComponent } from 'react';

export const ContentLoading: FunctionComponent = () => (
  <div>
    <Skeleton active title={false} />
    <Skeleton.Input active size="large" />
    <Skeleton.Input active size="large" />
  </div>
);
